// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"62":"b367049c","265":"75286f06"}[chunkId] + ".chunk.css";
};